export const carBrands = {
    "jaguar":{name:"jaguar",title:"Jaguar",link:"jaguar",locations:[{name:'south',url:'https://www.google.com/maps/place/BMW+Jorssen+Noord/@51.2672301,4.4598296,17z/data=!3m1!4b1!4m5!3m4!1s0x47c3f7fd76c1a37b:0x8070d77a42ff40f1!8m2!3d51.2672301!4d4.4620183'}]},
    "landrover":{name:"landrover",title:'LandRover',link:"landrover",locations:[{name:'noord',url:'https://www.google.com/maps/place/BMW+Jorssen+Noord/@51.2672301,4.4598296,17z/data=!3m1!4b1!4m5!3m4!1s0x47c3f7fd76c1a37b:0x8070d77a42ff40f1!8m2!3d51.2672301!4d4.4620183'},{name:'zuid',url:'https://www.google.com/maps/place/BMW+Jorssen+Zuid/@51.1461897,4.3795269,17z/data=!3m1!4b1!4m5!3m4!1s0x47c3f10ceb222c35:0x2cd4a25c7c4e9dd7!8m2!3d51.1461864!4d4.3817156'}]}
}
export const carModels = [
	"Jaguar E-PACE", "Jaguar F-PACE", "Jaguar F-TYPE", "Jaguar I-PACE", "Jaguar XE", "Jaguar XF", "Jaguar XJ",
	"Land Rover Defender", "Land Rover Discovery", "Land Rover Discovery Sport", "Land Rover Range Rover",
	"Land Rover Range Rover Evoque", "Land Rover Range Rover Sport", "Land Rover Range Rover Velar"
];

/** Models per brand: brand title (from carBrands) -> model name prefix */
export const brandModelPrefix = {
	[carBrands.jaguar.title]: "Jaguar ",
	[carBrands.landrover.title]: "Land Rover "
};

export function getModelsForBrand(brandName) {
	if (!brandName) return carModels;
	const prefix = brandModelPrefix[brandName];
	if (!prefix) return carModels;
	return carModels.filter((model) => model.startsWith(prefix));
}

export const days = ["Zon","Maan","Dins","Woens","Donder","Vrij","Zater"];
export const months =["Jan","Feb","Maart","April","Mei","Juni","Juli","Aug","Sept","Okt","Nov","Dec"];
